export default "__VITE_ASSET__CC0NFuXZ__"